import TransactionModal from "./transactionModal.js";
import { $_GET, trans } from "../globalFunctions.js";

export default class DecreasePoolModal extends TransactionModal {
  constructor(companyId) {
    super("decrease-pool-modal", companyId);
    this.pools = {};
    this.$pool = this.$form.querySelector('[name="pool"]');
    this.$availableShares = this.$form.querySelector("[data-available-shares]");
    this.$amount = this.$form.querySelector('[name="amount"]');
    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "pool",
        varType: "int",
        required: true,
      },
      {
        name: "amount",
        varType: "int",
        required: true,
      },
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "documents",
        varType: "simple-array",
        type: "int",
      },
      {
        name: "notes",
      },
    ];

    Promise.all([this.documentsPromise, this.setupPools().then(() => {})]).then(
      () => {
        this.whenReady();
      }
    );
    this.setupForm();
  }

  whenReady() {
    super.whenReady();

    const poolId =
      this.currentData != null ? this.currentData.pool : this.$pool.value;
    this.getPoolShares(parseInt(poolId));
    this.checkIfHasPools();
  }

  checkIfHasPools() {
    if (this.$form.querySelectorAll('[name="pool"] option').length === 0) {
      setTimeout(() => {
        this.hide();
      }, 1000 * 2);
      const poolModal = peque.transactionSelectionModal.showModal("add-pool");
      peque.navigation
        .showError(trans("you_must_create_a_pool_first"))
        .then(() => {
          poolModal.$form.querySelector('[name="name"]').focus();
        });
    }
  }

  setupForm() {
    const $date = this.$form.querySelector('[name="date"]');
    $date.valueAsDate = new Date();

    $date.addEventListener("change", () => {
      this.getPoolShares(parseInt(this.$pool.value));
    });

    this.$pool.addEventListener("change", () => {
      this.getPoolShares(parseInt(this.$pool.value));
    });

    this.$amount.addEventListener("input", () => {
      const amount = parseInt(this.$amount.value);

      if (
        typeof this.$amount.max === "undefined" ||
        this.$amount.max.length < 1
      ) {
        return;
      }

      if (amount > parseInt(this.$amount.max)) {
        this.$amount.value = this.$amount.max;
      }
    });
  }

  getPoolShares(poolId) {
    poolId = parseInt(poolId);

    peque
      .api(
        "shares/count",
        {
          receiver_id: poolId,
          receiver_type: peque.SHARE_RECEIVER_TYPE_POOL,
          company: this.companyId,
          simulation: $_GET("simulation"),
          date: this.$form.querySelector('[name="date"]').value,
        },
        "get"
      )
      .then((response) => {
        if (response.error > 0) {
          return;
        }
        const availableShares =
          response.result +
          (this.currentData ? Math.abs(this.currentData.amount) : 0);

        this.$availableShares.querySelector("i").innerText =
          peque.formatNumber(availableShares);
        this.$amount.max = availableShares;
      });
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.simulation =
          typeof window.pequeData.simulation === "undefined"
            ? $_GET("simulation")
            : window.pequeData.simulation;
        data.type = peque.TRANSACTION_TYPE_POOL_DECREASE;

        peque
          .api("transactions", JSON.stringify(data), "post")
          .then((response) => {
            this.mutateReactTransactions();
          })
          .catch((response) => {
            this.enableSubmitButton(true);
            if (
              response.error ===
              peque.ERROR_THERE_ARE_MORE_GRANTED_SHARES_THAN_GIVEN_VALUE
            ) {
              peque.navigation.showError(
                trans("cant_decrease_pool_shares_in_use")
              );
            }
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);
        if (typeof error.el === "undefined") {
          console.error(error);
          return;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
